export function setItem(storage) {
  return function execute(key, data) {
    if (storage && storage.setItem) {
      storage.setItem(key, data);
    }
  };
}
const localStorage = window && window.localStorage ? window.localStorage : {};
export default setItem(localStorage);
